import { stockAdvertiser } from './advertiser'

export const queries = {
  stockAdvertiser,
}
export default queries
